
import React, { useEffect } from 'react'; // Importa React y el hook useEffect

const Simetrias = () => { // Define el componente funcional Interact
  useEffect(() => { // Hook que se ejecuta cuando el componente se monta
    // Cambia el estilo de display de los elementos para hacerlos visibles
    const elements = document.querySelectorAll('.interact'); // Selecciona todos los elementos con la clase 'interact'
    elements.forEach((element) => { // Itera sobre cada uno de esos elementos
      element.style.display = 'inline'; // Cambia su display a 'inline' para hacerlos visibles
    });

    const canvas = document.querySelector(".p5Canvas"); // Selecciona el canvas con la clase 'p5Canvas'
    canvas.style.display = "inline"; // Hace visible el canvas cambiando su display a 'inline'

    // Función de limpieza para restaurar los estilos cuando el componente se desmonte
    return () => {
      elements.forEach((element) => { // Itera sobre los elementos con la clase 'interact'
        element.style.display = ''; // Restaura el estilo de display a su valor por defecto
      });
      canvas.style.display = ""; // Restaura el estilo de display del canvas a su valor por defecto
    };
  }, []); // Este efecto solo se ejecuta cuando el componente se monta

  return (
    <div> {/* Contenedor vacío que no renderiza nada visualmente */}
    </div>
  );
};

export default Simetrias; // Exporta el componente Interact